export default __webpack_public_path__ + "fonts/Roboto-500-greek-ext17.woff2";